<template>
  <div class="layout-options-setting-dialog">
    <el-collapse v-model="activeNames">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <el-collapse-item title="排列" name="1" v-if="!disableSetColAndRow && !isLoginLayout && !isSearchComponent">
        <template slot="title">
          排列
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick(1)"></i>
        </template>
        <div class="setting-item clearFloat">
          <div class="content">
            <div class="content-item mb16">
              <!-- 不能删除 登录框组件需要 -->
              <div class="mb16" v-if="isLoginEngine">
                <slider-and-input
                  inputWidth="small"
                  :value.sync="topHeight"
                  title="标题栏高度"
                  :sliderMax="999"
                  :sliderMin="0"
                  suffix="px"
                />
              </div>
              <emptyLayoutComponent :options="options" :isLayout="true" v-if="!isLoginEngine" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="排列" name="1" v-if="openAutoLayout && showRowColLayout">
        <rowColLayoutSetting :options="activeCol.componentBoxOptions" :ids="ids" @update="handleColSet"/>
      </el-collapse-item>
      <el-collapse-item title="背景" name="2">
        <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
      </el-collapse-item>
      <el-collapse-item title="边框" name="3">
        <div>
          <div class="content-item verticallyCenter mb8">
            <el-checkbox v-model="showBorder">显示边框</el-checkbox>
            <el-tooltip
              popper-class="width200"
              effect="dark"
              content="边框颜色为线性渐变或径向渐变时：背景颜色的透明度必须为1。此时背景模糊不生效；虚线、点线不生效。"
              placement="top"
              :open-delay="1000"
            >
              <span class="tips-btn icon-portal-info2"></span>
            </el-tooltip>
          </div>
          <cx-border
            v-if="showBorder"
            :borderWidth.sync="borderWidth"
            :borderStyle.sync="borderStyle"
            :borderColor.sync="borderColor"
            :borderIsThemeColor.sync="borderIsThemeColor"
            :activeNameColor.sync="borderActiveNameColor"
            :showGradientBorder="true"
            :options="options"
          />
        </div>
        <div class="content-item mt12">
          <border-radius
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边距" name="4">
        <div class="setting-item">
          <div class="content">
            <div class="content-item">
              <cx-padding
                v-if="checkShowTabs('边距')"
                :paddingTypeFlag.sync="topNavPaddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="更多" name="5">
        <div class="setting-item" v-if="checkShowTabs('外观')">
          <div class="content">
            <slider-and-input
              class=""
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
            <div class="content-item mt8">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <div class="content-item mt8">
              <public-style :options="options" :ids="ids"></public-style>
            </div>
            <div class="setting-item mt16 cx_style" style="line-height: 18px">
              <el-checkbox v-model="showCropping">裁剪内容</el-checkbox>
              <span class="third-text">(仅预览页生效)</span>
              <i class="tips-btn icon-portal-info2" @click="explainDialogClick(2)"></i>
            </div>
            <div class="setting-item mt16" style="line-height: 18px" v-if="!isLoginLayout && !isLoginEngine">
              <el-checkbox v-model="showScorll">开启滚动</el-checkbox>
              <i class="tips-btn icon-portal-info2" @click="explainDialogClick(3)"></i>
            </div>
            <div class="setting-item mt8 card" v-if="!isLoginLayout && showScorll">
              <div class="set-item">
                <span class="title">滚动方式</span>
                <div class="content">
                  <SliderSelect :options="scrollTypeList" :value.sync="scrollTypeVal" :useToolTip="true"></SliderSelect>
                </div>
              </div>
              <div v-if="options.showScorll">
                <div v-if="!singleRowOrColFlag" class="set-item">
                  <span class="title">滚动方向</span>
                  <div class="content">
                    <SliderSelect :options="scrollDirectionList" :value.sync="scrollDirectionVal"></SliderSelect>
                  </div>
                </div>
                <div class="set-item">
                  <p class="font14 title" v-if="scorllType === true">内容宽度</p>
                  <p class="font14 title" v-if="scorllType === 'vertical'">内容高度</p>
                  <slider-and-input
                    inputWidth="large"
                    inputHeight="small"
                    :value.sync="contentWidth"
                    title=""
                    :sliderMin="100"
                    :sliderMax="500"
                    suffix="%"
                  />
                </div>
              </div>
              <div v-else>
                <div class="set-item">
                  <span class="title">切换速度</span>
                  <div class="content">
                    <single-input
                      :value.sync="scrollSpeed"
                      inputSuffixs="ms"
                      :min="1000"
                      :max="20000"
                    />
                  </div>
                </div>
                <div class="set-item">
                  <span class="title">停留时间</span>
                  <div class="content">
                    <single-input
                      :value.sync="waitTime"
                      inputSuffixs="ms"
                      :min="0"
                      :max="4000"
                    />
                  </div>
                </div>
                <cx-check-box :value.sync="hoverStopScroll">鼠标移入时停止滚动</cx-check-box>
              </div>
            </div>
            <div class="content-item verticallyBetweenCenter mt12" v-if="openAutoLayout">
              <span class="verticallyCenter">布局模式<i class="tips-btn icon-portal-info2" @click="explainAutoDialog = true"></i></span>
              <el-select v-model="autoLayoutType" style="width: 120px;">
                <el-option v-for="(item, index) in layoutTypeList" :key="index" :label="item.label" :value="item.value">
                  <span style="font-size: 13px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="6">
        <div class="setting-item">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
    <asyncPluginSettingSubmit
      :pluginName="options.pluginName"
      componentName="layoutComponent"
      :options="options"
      type="Setting"
      :rect_id="rect_id"
      :container_id="container_id"
    />
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        {{ explainTips }}<span>{{ explainTitle }}</span>
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainAutoDialog" custom-class="explainDialog">
      <div class="auto-layout-body">
      <p class="fs14 tips">
        <span>排列模式：</span>
      </p>
      <ul>
        <li>开启排列模式后，布局内部元素会按照一定方向排列，配合行布局组件可以实现均匀的排列效果</li>
      </ul>
      <p class="fs14 tips">
        <span>功能说明：</span>
      </p>
      <p>
        通常情况下，一个网页的元素是遵从一定的顺序进行排列，例如2张图片横向排列，第3张以及后续图片都希望自动往左侧填充，超过宽度则自动换行，不仅可以减少整理页面的时间还可以实现更灵活的自适应效果。可以理解「自动布局」是为了简化原生页面使用Flex属性，并且达到类似的效果，你可以做到：
      </p>
      <ul>
        <li>让按钮或卡片随文本增减而自动调整尺寸</li>
        <li>将列表快速重新排序</li>
        <li>实现更多更复杂元素的全自动排布</li>
      </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "../publicSetting/controlWidthAndSizeAndZindex.vue"
import defaultBgImage from "../../../assets/images/default_image.png"
import elementPluginSetting from "../publicSetting/elementPluginSetting.vue"
import emptyLayoutComponent from "../emptyLayoutComponent/emptyLayoutComponent.vue"
import { withMethodsHistoryCombine } from "utils/revork"
import rowColLayoutSetting from "../../../materials/autoLayout/toolbars/setting/rowColLayoutSetting.vue"
import { handleFindLayoutComponentOptionsCols, checkIrregularLayout } from "../../../utils"
import publicStyle from "publicSetting/publicStyle.vue"
import SliderSelect from "modules/components/sliderSelect.vue"
import { CATEGORY_MODE } from "@/consts"
export default withMethodsHistoryCombine({
  components: {
    controlWidthAndSizeAndZindex,
    elementPluginSetting,
    emptyLayoutComponent,
    rowColLayoutSetting,
    publicStyle,
    SliderSelect
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2"],
      defaultBgImage: defaultBgImage,
      shapeChecked: true,
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("../../../assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("../../../assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("../../../assets/images/dotted-1.png")
        }
      ],
      displayPositionList: [
        {
          title: "上",
          label: "top"
        },
        {
          title: "下",
          label: "bottom"
        },
        {
          title: "左",
          label: "left"
        },
        {
          title: "右",
          label: "right"
        }
      ],
      displayPositionClassList: [
        {
          class: "signal_tb",
          label: "top"
        },
        {
          class: "signal_bt",
          label: "bottom"
        },
        {
          class: "signal_lr",
          label: "left"
        },
        {
          class: "signal_rl",
          label: "right"
        }
      ],
      top_status: true,
      contextPath: "",
      before: null,
      explainDialog: false,
      explainTips: "",
      explainTitle: "",
      explainImgSrc: require("../../../assets/images/tipsVideoImg/cropping-img.png"),
      explainVideoSrc: "",
      translate: 0,
      layoutTypeList: [
        {
          label: "自由拖拽",
          value: "free"
        },{
          label: "纵向排列",
          value: "vertical"
        },{
          label: "横向排列",
          value: "horizon"
        },
      ],
      explainAutoDialog: false,
      scrollTypeList: [
        {
          label: "手动",
          value: "manual"
        },
        {
          label: "自动",
          value: "auto",
          tip: "仅支持排列为1行或1列时使用",
          disabled: true
        }
      ],
      scrollDirectionList: [
        {
          value: "horizontal",
          icon: "icon-portal-direction-h"
        },
        {
          value: "vertical",
          icon: "icon-portal-direction-v"
        }
      ]
    }
  },
  watch: {
    "options.reload": {
      deep: true,
      handler(n, o) {
        if (n) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.$changeOptionsEV(false, "reload", false)
            }, 100)
          })
        }
      }
    },
    singleRowOrColFlag: {
      immediate: true,
      handler(n) {
        if(n === 1) {
          this.$changeOptionsEV(true, "scorllType", false, false, false, true)
        }
        if(n === 2) {
          this.$changeOptionsEV("vertical", "scorllType", false, false, false, true)
        }
      }
    }
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    this.initDisplaySetting()
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    opacity: {
      get() {
        return this.options.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    isDraggable() {
      if (this.options && !this.options.hasOwnProperty("draggable")) {
        return true
      }
      return this.options.draggable
    },
    showLayoutSetting() {
      if (this.options.hasOwnProperty("showLayoutSetting") === false) return true
      return this.options.showLayoutSetting
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    displayPositionDataModel() {
      const titleOptions = this.options.titleOptions
      if (!titleOptions) {
        return
      }
      // 先给一个默认值
      let arr = [
        {
          type: "classification",
          position: "top",
          directionIndex: 0,
          elementInLayoutId: 3
        },
        {
          type: "pagination",
          position: "bottom",
          directionIndex: 1,
          elementInLayoutId: 0
        },
        {
          type: "more",
          position: "top",
          directionIndex: 0,
          elementInLayoutId: 0
        }
      ]
      for (let i = 0; i < titleOptions.length; i++) {
        for (let j = 0; j < titleOptions[i].elementOptions.length; j++) {
          let position = ["top", "bottom", "left", "right"]
          let data = {
            type: titleOptions[i].elementOptions[j].type,
            position: position[i],
            directionIndex: i,
            elementInLayoutId: titleOptions[i].elementOptions[j].elementInLayoutId
          }
          switch (titleOptions[i].elementOptions[j].type) {
            // case "title":
            //   arr[0] = data
            //   break
            // case "subTitle":
            //   arr[1] = data
            //   break
            case "classification":
              arr[0] = data
              break
            case "pagination":
              arr[1] = data
              break
            // case "more":
            //   arr[3] = data
            //   break
            default:
          }
        }
      }
      return arr
    },
    disableSetColAndRow() {
      return this.hasProperty(this.options, "disableSetColAndRow")
    },
    displayTypeList() {
      let titleOptions = this.options.titleOptions
      if (this.options.name == "搜索") return
      if (this.options.pluginName && this.options.pluginName[0] == "loginLayoutComponent") return
      if (this.options.pluginName && this.options.pluginName[0] == "loginEngineComponentPlugin") return
      return [
        {
          select: titleOptions[this.displayPositionDataModel[0].directionIndex].elementOptions.find(
            it => it.elementInLayoutId === this.displayPositionDataModel[0].elementInLayoutId
          )?.isShow,
          title: "显示分类",
          type: "classification"
        },
        {
          select:
            titleOptions[this.displayPositionDataModel[1].directionIndex].elementOptions.find(
              it => it.elementInLayoutId === this.displayPositionDataModel[1].elementInLayoutId
            )?.isShow || false,
          title: "显示分页",
          type: "pagination"
        },
        {
          select: titleOptions[this.displayPositionDataModel[2].directionIndex].elementOptions.find(
            it => it.elementInLayoutId === this.displayPositionDataModel[2].elementInLayoutId
          )?.isShow,
          title: "显示更多按钮",
          type: "more"
        }
      ]
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.borderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options ? this.options.borderColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (this.options.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderShadowChecked: {
      get() {
        return this.boxShadowColor !== "rgba(0, 0, 0,0.5)"
      },
      set(val) {
        if (val) {
          this.boxShadowColor = "#ffffff"
        } else {
          this.boxShadowColor = "rgba(0, 0, 0,0.5)"
        }
      }
    },
    boxShadowColor: {
      get() {
        return this.options ? this.options.boxShadowColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    clipSize: {
      get() {
        return this.options ? this.options.clipSize : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clipSize", false)
      }
    },
    repeatType: {
      get() {
        return this.options ? this.options.repeatType : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "repeatType", false)
      }
    },
    alignType: {
      get() {
        return this.options ? this.options.alignType : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "alignType", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          if (background.length === 1 && background[0].type === "color" && !background[0].color) {
            background[0].color = "rgba(255,255,255,0)"
          }
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    borderActiveNameColor: {
      get() {
        return this.options.borderActiveNameColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderActiveNameColor", false)
      }
    },
    topNavPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("topNavPaddingTypeFlag")) {
          if (
            ((this.topNavPaddingTop === this.topNavPaddingRight) === this.topNavPaddingLeft) ===
            this.topNavPaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingTypeFlag", "topNavPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    pageType() {
      return this.$store.state.states.getDataPageIds.pageType
    },
    contentWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "contentWidth", "contentWidth", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentWidth", false)
      }
    },
    showScorll: {
      get() {
        return this.options.showScorll || this.options.turnOnScroll
      },
      set(newVal) {
        if (newVal === false) {
          this.$changeOptionsEV([100, false, newVal], ["contentWidth", "turnOnScroll", "showScorll"], false)
        } else {
          this.$changeOptionsEV([false, newVal], ["turnOnScroll", "showScorll"], false)
        }
      }
    },
    scorllType: {
      get() {
        return this.options.hasOwnProperty("scorllType") ? this.options.scorllType : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "scorllType", false)
      }
    },
    isLoginEngine() {
      return this.options && this.options.pluginName && this.options.pluginName[0] == "loginEngineComponentPlugin"
    },
    isSearchComponent() {
      return (
        this.options &&
        (this.options.pluginName?.includes("searchComponentPlugin") || this.options.menuName === "列表页搜索")
      )
    },
    topHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    // 登录组件
    isLoginLayout() {
      return this.options && this.options.pluginName && this.options.pluginName[0] == "loginLayoutComponent"
    },
    openAutoLayout() {
      return  this.isLoginLayout || this.options?.menuName === "超星头像" || this.options?.menuName === "列表页搜索"
    },
    // 是否裁剪内容
    showCropping: {
      get() {
        return this.options.hasOwnProperty("showCropping") ? this.options.showCropping : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showCropping", false)
      }
    },
    activeCol() {
      const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      const pOptions = [this.options.rows[useActiveIndex]]
      // 如果这个节点已经被删除了，直接找根节点，避免空对象
      return (
        handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid) ||
        handleFindLayoutComponentOptionsCols(pOptions, pOptions[0].cols[0].uid)
      )
    },
    showRowColLayout: {
      get() {
        const componentBoxOptions = this.activeCol?.componentBoxOptions
        return componentBoxOptions.hasOwnProperty("showRowColLayout") ? componentBoxOptions.showRowColLayout : false
      },
      set(newVal) {
        this.handleColSet("showRowColLayout", newVal)
      }
    },
    autoLayoutType: {
      get() {
        const componentBoxOptions = this.activeCol?.componentBoxOptions
        if (this.showRowColLayout) {
          return componentBoxOptions.rowColDirection || "vertical"
        } else {
          return "free"
        }
      },
      set(newVal) {
        if (newVal === "free") this.showRowColLayout = false
        else {
          this.showRowColLayout = true
          this.handleColSet("rowColDirection", newVal)
        }
      }
    },
    singleRowOrColFlag() {
      let flag = 0
      const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      const { regular, rowLens, colLens } = checkIrregularLayout(this.options.rows[useActiveIndex])
      if (regular && rowLens === 1 && colLens > 1) {
        flag = 1
      } else if (rowLens > 1 && colLens === 1) {
        flag = 2
      } else {
        flag = 0
      }
      // 开启了分页，不支持自动滚动
      const pagination = this.options.titleOptions[1].elementOptions.find(item => {
        return item.type === "pagination"
      })
      this.scrollTypeList[1].disabled = !(flag && !pagination?.isShow)
      return flag
    },
    scrollTypeVal: {
      get() {
        return this.options.turnOnScroll ? "auto" : "manual"
      },
      set(newVal) {
        if(newVal === "manual") {
          this.$changeOptionsEV([false, true], ["turnOnScroll", "showScorll"], false)
        }
        if(newVal === "auto") {
          this.$changeOptionsEV([true, false], ["turnOnScroll", "showScorll"], false)
        }
      }
    },
    scrollDirectionVal: {
      get() {
        return this.options.scorllType === "vertical" ? "vertical" : "horizontal"
      },
      set(newVal) {
        if(newVal === "horizontal") {
          this.scorllType = true
        }
        if(newVal === "vertical") {
          this.scorllType = "vertical"
        }
      }
    },
    hoverStopScroll: {
      get() {
        return this.options.hoverStopScroll || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverStopScroll", false)
      }
    },
    scrollSpeed: {
      get() {
        return this.options.scrollSpeed || 6000
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "scrollSpeed", false)
      }
    },
    waitTime: {
      get() {
        // 以前的单位是s，现在转成ms，加个字段标识
        let waitTime = this.options.hasOwnProperty("waitTime") ? this.options.waitTime : 1
        if(!this.options.waitTimeUnit) {
          waitTime = waitTime * 1000
          this.$changeOptionsEV(["ms", waitTime], ["waitTimeUnit", "waitTime"], false, false, false, true)
        }
        return waitTime
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "waitTime", false)
      }
    }
  },
  methods: {
    handleColSet(key, val) {
      if (this.activeCol.componentBoxOptions[key] === val && typeof val !== "object") return
      this.$changeOptionsEV(val, key, false, null, {
        ...this.ids,
        uid: this.activeCol.uid
      })
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainTitle = ""
          this.explainTips = "通过调整行数或列数，来对数据排列和数量进行调整"
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/pailie-video.mp4")
          break
        case 2:
          this.explainTitle = "仅在预览页生效"
          this.explainTips = "勾选裁剪内容后，任何溢出容器的内容都将被隐藏，不会显示在容器的边界之外。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/cropping-img.png")
          this.explainVideoSrc = ""
          break
        case 3:
          this.explainTitle = ""
          this.explainTips =
            "开启滚动后，可以选择横向滚动或者竖向滚动，滚动内容宽度必须大于滚动区宽度，才能实现滚动效果。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/open-scroll.png")
          this.explainVideoSrc = ""
          break
        default:
      }
    },
    checkShowTabs(name) {
      if (typeof this.showLayoutSetting === "boolean") return this.showLayoutSetting
      return !!this.showLayoutSetting.find(it => it === name)
    },
    hasComponent(name, type) {
      try {
        require(`./plugin/${name}/${name}-${type}.vue`)
      } catch (error) {
        return false
      }
      return true
    },
    checkboxHandle(flag) {
      switch (flag) {
        case 1:
          this.shapeType = "square"
          this.borderTopLeftRadius = 0
          this.borderTopRightRadius = 0
          this.borderBottomLeftRadius = 0
          this.borderBottomRightRadius = 0
          break
        case 2:
          this.borderColor = "#FFFFFF"
          this.borderWidth = 1
          this.borderStyle = "solid"
          this.changeBorderSelection()
          break
        case 3:
          this.boxShadowColor = "#FFFFFF"
          this.boxShadowH = 0
          this.boxShadowV = 0
          this.boxShadowBlur = 0
          this.boxShadowSpread = 0
          break
        case 4:
          this.rotate = "0deg"
          break
      }
    },
    initDisplaySetting() {
      this.displayPositionDataModel?.forEach((item, index) => {
        return this.options.titleOptions.some((item1, index1) => {
          return item1.elementOptions.some((item2, index2) => {
            if (item2.type == item.type) {
              item.position = item1.type
              item.elementInLayoutId = item2.elementInLayoutId
              item.directionIndex =
                item.position == "top" ? 0 : item.position == "bottom" ? 1 : item.position == "left" ? 2 : 3
              return true
            }
          })
        })
      })
    },
    checkboxDisplayHandle(index) {
      const temp = this.displayPositionDataModel[index]
      const activeLayoutTitle = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: temp.directionIndex,
        elementInLayoutId: temp.elementInLayoutId
      }
      this.$store.dispatch(this.request_prefix + "/layoutTitleDisplayIsShow", activeLayoutTitle)
    },
    judgeIsShow(data) {
      let tf = false
      data.forEach((item, index) => {
        if (item.isShow) {
          tf = true
        }
      })
      return tf
    },
    radioDisplayHandle(flag, label, newIndex) {
      const temp = this.displayPositionDataModel[flag]
      const activeLayoutTitle = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: temp.directionIndex,
        elementInLayoutId: temp.elementInLayoutId,
        position: temp.position
      }
      // 从上/下 切换到左/右  对换掉宽高
      let isDiffDirection
      if ([0, 1].indexOf(temp.directionIndex) > -1 && [0, 1].indexOf(newIndex) === -1) {
        isDiffDirection = true
      } else if ([2, 3].indexOf(temp.directionIndex) > -1 && [2, 3].indexOf(newIndex) === -1) {
        isDiffDirection = true
      }
      if (isDiffDirection) {
        let curObj = this.options.titleOptions[temp.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === temp.elementInLayoutId
        )
        let oldWidth = curObj.options.width,
          oldHeight = curObj.options.height
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: temp.directionIndex,
          elementInLayoutId: temp.elementInLayoutId,
          option_name: "width",
          option_val: oldHeight
        })
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: temp.directionIndex,
          elementInLayoutId: temp.elementInLayoutId,
          option_name: "height",
          option_val: oldWidth
        })
      }
      this.$store.dispatch(this.request_prefix + "/layoutTitleDisplay", activeLayoutTitle)
      this.initDisplaySetting()
    },
    increase() {
      this.$refs.upBtn.style.background = "#EBEBEB"
      this.top++
    },
    decrease() {
      this.$refs.downBtn.style.background = "#EBEBEB"
      this.top--
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    stop(time) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, time)
      })
    }
  }
})
</script>

<style scoped lang="scss">
.signal_tb {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_tb .item1 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_tb .item2 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_bt .item1 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt .item2 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_lr .item1 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr .item2 {
  width: calc(100% - 24px);
  height: 62px;
  float: left;
  background: rgba(61, 130, 242, 0.1);
}
.signal_rl {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_rl .item1 {
  width: calc(100% - 24px);
  height: 62px;
  background: rgba(61, 130, 242, 0.1);
  float: left;
}
.signal_rl .item2 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.keep-all {
  word-break: keep-all;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--themeColor);
  padding: 8px 68px;
}
.childPageSettingBtn:hover {
  cursor: pointer;
}
.mr32 {
  margin-right: 32px;
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  margin-left: 16px;
  .num-btn {
    display: inline-block;
    width: 38px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
    }
  }
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 0;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.third-text {
  color: var(--thirdTextColor);
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn.height32 span {
  height: 26px;
  line-height: 26px;
  font-size: 13px;
}
.setting-item {
  .set-item {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 8px;
    .title {
      width: 56px;
      margin-right: 12px;
      line-height: 32px;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      flex-shrink: 0;
    }
    .content {
      flex: 1;
      overflow: hidden;
    }
    &:last-child {
      margin-bottom: 0;
    }
    ::v-deep.slider_and_input .el-input {
      width: 66px !important;
    }
  }
}
</style>
